export const REFERRAL_CODE_REGEX = /^\w+$/;
export const REGEX_VERIFY_BYTES32 = /^0x[0-9a-f]{64}$/;
